import { createFileRoute } from '@tanstack/react-router';

import { SetupSamlPage } from 'src/apps/enterprise/app/pages/SetupSaml';

export const Route = createFileRoute('/_auth/enterprise/enroll/setup-saml')({
  component: () => <SetupSamlPage />,
});
